import React from "react";
import { CheckCircle2, AlertTriangle, Clock, XCircle } from "lucide-react";

const MAP = {
  paid: { cls: "bg-successBrand/10 text-successBrand border-successBrand/20", icon: CheckCircle2, label: "Paid" },
  complete: { cls: "bg-successBrand/10 text-successBrand border-successBrand/20", icon: CheckCircle2, label: "Complete" },
  registered: { cls: "bg-successBrand/10 text-successBrand border-successBrand/20", icon: CheckCircle2, label: "Registered" },
  active: { cls: "bg-successBrand/10 text-successBrand border-successBrand/20", icon: CheckCircle2, label: "Active" },
  pending: { cls: "bg-gold/15 text-[#8A5F00] border-gold/40", icon: Clock, label: "Pending" },
  waitlisted: { cls: "bg-gold/15 text-[#8A5F00] border-gold/40", icon: Clock, label: "Waitlisted" },
  missing: { cls: "bg-alertBrand/10 text-alertBrand border-alertBrand/20", icon: AlertTriangle, label: "Missing" },
  expired: { cls: "bg-alertBrand/10 text-alertBrand border-alertBrand/20", icon: XCircle, label: "Expired" },
  refunded: { cls: "bg-slate-100 text-slateBrand border-slate-200", icon: XCircle, label: "Refunded" },
};

export default function StatusBadge({ status, label, testId }) {
  const key = (status || "").toLowerCase();
  const cfg = MAP[key] || { cls: "bg-slate-100 text-slateBrand border-slate-200", icon: Clock, label: status };
  const Icon = cfg.icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold ${cfg.cls}`}>
      <Icon className="h-3 w-3" />
      {label || cfg.label}
    </span>
  );
}
